import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Fiat } from "@models";
import { ICashPlusFiatWallet } from "@modules/cashplus/entities/cashplus.model";
import { PortfolioAssetProjection } from "@modules/portfolio/domain/entities/portfolio-projection.model";

@Component({
	selector: "cashplus-fiat-tile",
	templateUrl: "./cashplus-fiat-tile.component.html",
	styleUrls: ["./cashplus-fiat-tile.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CashPlusFiatTileUIComponent {
	// TODO: use casting
	@Input() public asset: PortfolioAssetProjection | ICashPlusFiatWallet = null;
	@Input() public isCashPlusOptIn: boolean = false;
	@Input() public defaultFiat: Fiat = null;
	@Input() public isCashPlusEligible: boolean = false;
	@Input() public isHidePortfolioActive: boolean = false;
}
